import { Injectable } from '@angular/core';
import { PackageService } from '../../data/package.service';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { AppState } from '../index';
import { MatSnackBar } from '@angular/material/snack-bar';
import { PackageFilterService } from '../../modules/shared/filter/package-filter.service';
import {
    packageTableAddAssist, packageTableChangePage,
    packageTableChangeQuery, packageTableFailure,
    packageTableRemoveAssist,
    packageTableRequest,
    packageTableSuccess
} from './package-table.actions';
import { catchError, map, mergeMap, tap, withLatestFrom } from 'rxjs/operators';
import { selectPackageTableQuery } from './package-table.state';
import { of } from 'rxjs';

@Injectable()
export class PackageTableEffects {
    constructor(private actions$: Actions, private packageService: PackageService, private store: Store<AppState>,
                private snackbar: MatSnackBar, private packageFilterService: PackageFilterService) {
    }

    packageTableRequest$ = createEffect(() => this.actions$.pipe(
        ofType(packageTableRequest),
        withLatestFrom(this.store.select(selectPackageTableQuery)),
        mergeMap(([ , query ]) => this.packageService.query(query).pipe(
            map((result) => packageTableSuccess(result))
        )),
        catchError((e) => of(packageTableFailure()))
    ));

    packageTableFailure$ = createEffect(() => this.actions$.pipe(
        ofType(packageTableFailure),
        tap(() => this.snackbar.open($localize`We are having difficulty communicating with the server.  Please try again later.`))
    ), { dispatch: false });

    packageTableChangeQuery$ = createEffect(() => this.actions$.pipe(
        ofType(packageTableChangeQuery, packageTableChangePage),
        map(() => packageTableRequest())
    ));

    packageTableFilterAdd$ = createEffect(() => this.actions$.pipe(
        ofType(packageTableAddAssist),
        withLatestFrom(this.store.select(selectPackageTableQuery)),
        map(([ action, query ]) => this.packageFilterService.applyAssist(query, action.id, action.parameter)),
        map(query => packageTableChangeQuery({ query }))
    ));

    packageTableFilterRemove$ = createEffect(() => this.actions$.pipe(
        ofType(packageTableRemoveAssist),
        withLatestFrom(this.store.select(selectPackageTableQuery)),
        map(([ action, query ]) => this.packageFilterService.removeAssist(query, action.id)),
        map(query => packageTableChangeQuery({ query }))
    ));

}
